import React, { useEffect, useState } from "react";
import {
  CardInnerDiv,
  CardWrapper,
  MyStakingSection,
  TextBoxDiv,
} from "./elements";
import {
  c98cardimg2,
  connectbtnimg,
  innerimg,
  textBox2,
  unstakebtn,
} from "assets";
import { Image } from "react-bootstrap";
import {
  MainCol,
  MainContainer,
  MainRow,
  ToastMessage,
} from "components/common";
import { CommonUtility } from "utility/common";
import { stakingAbi } from "utility/contract/nftStakingAbi";
import environment from "environment";
import { useWalletConnectClient } from "services/walletServices";
import { energyTokenAbi } from "utility/contract/energyTokenAbi";
import Loading from "components/common/loaders/loading";
import Timer from "./timer";
import { Link } from "react-router-dom";

const Mystaking = ({
  stakedDetail,
  getUserNfts,
  getClaimedReward,
  getUserStaked,
}) => {
  console.log("Stakewd detail", stakedDetail)
  const { web3Provider, account } = useWalletConnectClient();
  const [isLoading, setIsLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState(Number);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleUnstake = async (endTime, tokenId) => {
    try {
      setIsLoading(true);
      console.log("HANDLE UNSTAKE", endTime, tokenId);
      const contract = CommonUtility.contract(
        web3Provider,
        stakingAbi,
        environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN]
      );
      const stakeIndex = await contract.methods
        .getStakeIndex(account, tokenId)
        .call();
      const stakeDuration = await contract.methods
        .getStakingDurations(stakeIndex)
        .call();
      console.log("STAKE DURATION", stakeDuration);
      const reward = stakeDuration[0];
      const durationInDays = stakeDuration[1];
      const userReward = +reward * +durationInDays;
      console.log("userReward", userReward);
      const tokenContract = CommonUtility.contract(
        web3Provider,
        energyTokenAbi,
        environment.ENERGY_TOKEN[environment.DEFAULT_CHAIN]
      );
      const balance = await tokenContract.methods
        .balanceOf(environment.STAKING_CONTRACT[environment.DEFAULT_CHAIN])
        .call();
      console.log("BALANCE", balance);
      // if (+balance < +userReward)
      //   throw "Your reward is greater then contract balance. Try Later.";
      if (Date.now() / 1000 < +endTime)
        throw "Staking Duration not completed yet";
      const estimatedGasLimit = await contract.methods
        .unstake(tokenId)
        .estimateGas({ from: account });
      const currentGasPrice = await web3Provider.eth.getGasPrice();
      const txn = await contract.methods.unstake(tokenId).send({
        from: account,
        gasLimit: web3Provider.utils.toHex(
          +estimatedGasLimit + environment.GAS_LIMIT_BUFFER
        ),
        gasPrice: web3Provider.utils.toHex(
          +currentGasPrice + environment.GAS_PRICE_BUFFER
        ),
      });
      if (txn && txn.code == 4001) throw "User denied the transaction";
      if (!txn.status) throw "Transaction Failed";
      await getClaimedReward();
      await getUserNfts();
      await getUserStaked();
      if (txn.status) {
        setIsLoading(false);
        ToastMessage("Success!", "Transaction successful", "success");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error?.message) {
        ToastMessage("Error", error?.message, "error");
      } else {
        ToastMessage("Error", error, "error");
      }
    }
  };
  return (
    <MyStakingSection>
      {isLoading && <Loading content={"Transaction in progress"} />}

      <TextBoxDiv>
        <Image className="" src={textBox2} />
        <div>
          <h1 className="inner-text">
            MY <span>Staking</span>
          </h1>
        </div>
      </TextBoxDiv>
      <MainContainer fluid>
        <MainRow>
          {stakedDetail?.map((item) => (
            <MainCol lg={4}>

              <CardWrapper>
                <Image src={c98cardimg2} className="innerimg" />

                <CardInnerDiv>
                  <div className="mask1">
                    <Image src={item.image} fluid />
                  </div>
                  <h1>{item.title}</h1>

                  {/* <div className="content-div">
                    <h5>{item.name1}</h5>
                    <p>{item.value1}</p>
                  </div>
                  <div className="content-div">
                    <h5>{item.name2}</h5>
                    <p>{item.value2}</p>
                  </div> */}
                  {item?.attributes.map((item) => (
                    <>
                      <div className="content-div">
                        <h5>{item.name}</h5>
                        <p>{item.value}</p>
                      </div>
                    </>
                  ))}
                  {+currentTime > 0 &&
                    +item?.unstakeTime - +currentTime > 0 ?
                    <div className="register-btn-div2">
                      <Image
                        src={unstakebtn}
                        alt="button img"
                        className="btn-img"
                      />
                      <div
                        className="main-div"
                        onClick={() =>
                          handleUnstake(item?.unstakeTime, item.nftId)
                        }
                      >
                        <div>
                          <h1>{item.btnText}</h1>
                          <p>
                            Time left :{" "}
                            <span>
                              {+currentTime > 0 &&
                                +item?.unstakeTime - +currentTime > 0 ? (
                                <Timer
                                  duration={+item?.unstakeTime - +currentTime}
                                />
                              ) : (
                                "00:00:00"
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div> :
                    <div className="register-btn-div3">
                      <Image
                        src={connectbtnimg}
                        alt="button img"
                        className="btn-img"
                      />
                      <div
                        className="main-div"
                        onClick={() =>
                          handleUnstake(item?.unstakeTime, item.nftId)
                        }
                      >
                        <div>
                          <h1>{item.btnText}</h1>
                          {/* <p>
                            Time left :{" "}
                            <span>
                              {+currentTime > 0 &&
                                +item?.unstakeTime - +currentTime > 0 ? (
                                <Timer
                                  duration={+item?.unstakeTime - +currentTime}
                                />
                              ) : (
                                "00:00:00"
                              )}
                            </span>
                          </p> */}
                        </div>
                      </div>
                    </div>
                  }
                </CardInnerDiv>
              </CardWrapper>

            </MainCol>
          ))}
        </MainRow>
      </MainContainer>
    </MyStakingSection>
  );
};

export default Mystaking;
